import { Address } from './address.model';

// this model is to match the agent model coming from the angular 1 model, api models may be different
export class Agent {
    public agentId: string;
    public agentCode: string;
    public agencyId: string;
    public agencyCode: string;
    public auth0Id: string;
    public agencyName: string;

    /**
     * The agent's full name.
     */
    public name: string;
    public firstName: string;
    public lastName: string;
    public birthdate: string;
    public emailAddress: string;
    public phoneNumber: string;
    public timezone: string;
    public role: string;
    public address: Address;
    public canPayWithInvoice: boolean;
    public canSeeCommission: boolean;
    public copyMeWhenCustomersAreSentPolicyEmails: boolean;
    public isAmbassador: boolean;
    public isSuperUser: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/models/agent.model.ts